import * as yup from "yup";

export const createAddTruckVehicleScheme = yup.object().shape({
  dotNumber: yup
    .string()
    .nonNullable(true)
    .trim()
    .required("Dot number is required"),
  make: yup.string().nonNullable(true).trim().required("Make is required"),
  model: yup.string().nonNullable(true).trim().required("Model is required"),
  color: yup.string().nonNullable(true).trim().required("Color is required"),
  plateNumber: yup
    .string()
    .nonNullable(true)
    .trim()
    .required("Plate number is required"),
});

export const createAddTrailerVehicleScheme = yup.object().shape({
  trailerNumber: yup
    .string()
    .nonNullable(true)
    .trim()
    .required("Trailer number is required"),
  plateNumber: yup
    .string()
    .nonNullable(true)
    .trim()
    .required("Plate number is required"),
});

export const createAddPersonalVehicleScheme = yup.object().shape({
  make: yup.string().nonNullable(true).trim().required("Make is required"),
  model: yup.string().nonNullable(true).trim().required("Model is required"),
  color: yup.string().nonNullable(true).trim().required("Color is required"),
  plateNumber: yup
    .string()
    .nonNullable(true)
    .trim()
    .required("Plate number is required"),
});

export const updateTruckVehicleScheme = yup.object().shape({
  dotNumber: yup
    .string()
    .trim()
    .strict(true)
    .required("Dot number is required"),
  make: yup.string().trim().strict(true).required("Make is required"),
  model: yup.string().trim().strict(true).required("Model is required"),
  color: yup.string().trim().strict(true).required("Color is required"),
});

export const updateTrailerVehicleScheme = yup.object().shape({
  trailerNumber: yup
    .string()
    .trim()
    .strict(true)
    .required("Trailer number is required"),
});

export const updatePersonalVehicleScheme = yup.object().shape({
  make: yup.string().trim().strict(true).required("Make is required"),
  model: yup.string().trim().strict(true).required("Model is required"),
  color: yup.string().trim().strict(true).required("Color is required"),
});
